import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'mojo-input',
  templateUrl: './mojo-input.component.html',
  styleUrls: ['./mojo-input.component.scss'],
})
export class MojoInputComponent implements AfterViewInit {
  @Input() searchControl: UntypedFormControl;
  @Input() placeholderText = 'Search';
  /**
   * Supports only material icons (no custom)
   */
  @Input() prefixIcon: string;
  /**
   * Supports only material icons (no custom)
   */
  @Input() suffixIcon: string;
  @Input() mobile = false;
  @Output() suffixClicked = new EventEmitter();
  @Output() prefixClicked = new EventEmitter();

  @ViewChild('searchInput') searchInput: ElementRef;

  onSuffixClicked() {
    this.suffixClicked.emit();
  }

  onPrefixClicked() {
    this.prefixClicked.emit();
  }

  ngAfterViewInit(): void {
    this.searchInput.nativeElement.focus();
  }
}
